import React, { useEffect, useState } from 'react'

//api
import { getParentContents } from '@/api/lists'

//interfaces
import { SortBy } from  '@/interfaces/toggle'
import { ITableColumn, ITableContent } from  '@/interfaces/simpleTable'
import { ParentContent } from  '@/interfaces/content'

//components
import ViewParentsTitleContainer from './ViewParentsTitleContainer'
import ViewParentsGoToLink from './ViewParentsGoToLink'

//helpers
import { BuildPath } from  '@/helpers/Paths'
import { getImageAsset } from  '@/helpers/Images'



export const useViewParents = ({contentId}:{contentId:string}) => {
    const [sort, setSort] = useState<{sort: SortBy, sortBy: 'name' | 'audience'}>({sort: SortBy.ASCENDING, sortBy:'name'})
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [currentSkip, setCurrentSkip] = useState<number>(0);
    const [table, setTable] = useState<ITableContent>({columns :[], rows: []}) 
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [parentList, setParentList] = useState<ParentContent[]>([])

    useEffect(() => {
        if(contentId) {
            updateParentContents('new');
        }
       
    }, [sort.sort, sort.sortBy, contentId])

    useEffect(() => {
        setTable(formatTable(parentList))
    },[parentList])


    async function updateParentContents(type: 'paginate' | 'new' = 'new'): Promise<void>{
        setIsLoading(true);
        getParentContents(contentId, {
            sort: sort.sort, 
            sortBy: sort.sortBy,
            top: 20,
            skip: type === 'paginate' ? currentSkip : 0
        }).then((data) => {
            setTotalRecords(data.total)
            // getting an odd top can throw off pagination so best to just not set it if we're doing a content refresh
            setCurrentSkip(data.skip);
            setParentList(type === 'paginate' ? [...parentList, ...data.records] : data.records)
        })
        .finally(() => {
            setIsLoading(false)
            return Promise.resolve();
        })
    }

    function nextPage(){
        updateParentContents('paginate')
    }

    function applySortToHeading(fieldname: 'listName' | 'audience'){
        const sortBy =  fieldname === 'audience' ? fieldname : 'name'
        return {
            onSortAscendingClick:() => setSort({sort:SortBy.ASCENDING, sortBy}),
            onSortDescendingClick:() => setSort({sort:SortBy.DESCENDING, sortBy})
        }
    }

    function getTableHeadings(): ITableColumn[] {
        return  [
            {title: 'List', isToggleButton:true, ...applySortToHeading('listName'), defaultSort: SortBy.ASCENDING},
            {title: 'Audience', isToggleButton:true, ...applySortToHeading('audience')},
            {title: 'Actions', isToggleButton:false},
        ]
    }

    function getTableRows(list: ParentContent[]){
        return  list.map(item => {
            const placeholderUrl = `${BuildPath()}/images/content-types/list_icon.svg`
        
            return {
                content:[
                    <ViewParentsTitleContainer
                        featureImageUrl={getImageAsset(140, item.featuredImageUrl || placeholderUrl)}
                        title={item.name || 'unpublished list'} key={`title-${item.contentId}`}
                        isPlaceholderImage={!item.featuredImageUrl}
                    />,
                    item.members,
                    <ViewParentsGoToLink key={item.contentId} url={String(item.contentId)}/>
                ]
            }
        })
         
    }

    function formatTable(list: ParentContent[]):ITableContent{
        return {
            columns: getTableHeadings(),
            rows: getTableRows(list)
        }
    } 

    function shouldFetchMore():boolean {
        return table.rows.length < totalRecords && !isLoading
    }

    return { table, nextPage, shouldFetchMore, isLoading }

}